import { render, staticRenderFns } from "./summaryDetails.vue?vue&type=template&id=069684b6&scoped=true&"
import script from "./summaryDetails.vue?vue&type=script&lang=js&"
export * from "./summaryDetails.vue?vue&type=script&lang=js&"
import style0 from "./summaryDetails.vue?vue&type=style&index=0&id=069684b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069684b6",
  null
  
)

export default component.exports